import { UStyles } from "@/app/utils/UStyles";
import styles from "./ToggleInput.module.css";

export type ToggleInputProps = {
  checked: boolean;
  onToggle: (checked: boolean) => void;
  label?: string;
  className?: string;
};

export default function ToggleInput({ checked, onToggle, label, className }: ToggleInputProps) {
  return (
    <button
      className={UStyles.classNames(
        styles.toggleBtn,
        checked ? styles.active : "",
        className || "",
      )}
      onClick={() => onToggle(!checked)}
      type="button"
    >
      {label && <span className={styles.toggleLabel}>{label}</span>}
      <div className={styles.toggleTrack}>
        <div className={styles.toggleThumb} />
      </div>
    </button>
  );
}
